import type { Box, GlobalFieldReference } from '@ps/web-martech-cms-types';
import classNames from 'clsx';
import React from 'react';

import { CMSReference } from '@swf/cms';

import styles from './CMSBox.scss';

const CMSBox: React.FC<Box> = ({ variant, body, direction }) => (
  <div
    className={classNames(styles.box, variant && styles[variant], direction && styles[direction])}
  >
    {body.map((item, index) => (
      <CMSReference key={index} {...(item as GlobalFieldReference)} />
    ))}
  </div>
);

export default CMSBox;
